<template>
  <modal
    header-text=""
    :button-text="$t('global.delete')"
    @action="deleteItem"
    @close="$emit('close')"
  >
    <div :class="$style.inputContainer">
      {{ $t('modal.confirmationMessages.deleteReportPack') }}
    </div>
  </modal>
</template>

<script>
  import Modal from '@/components/common/modal/schedule-modal.vue';

  export default {
    components: { Modal },
    methods: {
      close() {
        this.$emit('close');
      },
      async deleteItem() {
        this.close();
        this.$emit('update');
      },
    },
  };
</script>

<style lang="scss" module>
  .input {
    margin: 5px;
  }
  .inputContainer {
    font-size: 13px;
    margin: 5px;
  }
</style>
